/**
 * Converts Contentful's "LinkCollection" content type to the appropriate component
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Typography from 'components/theme/Typography'
import { convertRichTextToComponent } from '../utils'
import styles from './ContentfulLinkCollection.module.scss'

const ContentfulLinkCollection = ({
  title, links,
}) => (
  <div className={cx(styles.linkCollection)}>
    <Typography variant="h3">
      {title}
    </Typography>
    {convertRichTextToComponent(links, true)}
  </div>
)

ContentfulLinkCollection.propTypes = {
  title: PropTypes.string,
  links: PropTypes.object,
}

export default ContentfulLinkCollection
